import React, { useEffect, useState, useCallback, useMemo } from 'react';
import _ from 'lodash';
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { useModal, ModalNextEmitter } from '@jutro/components';
import { useBreakpoint } from '@jutro/layout';
import './App.scss';
import { ViewModelServiceFactory } from '@xengage/gw-portals-viewmodel-js';
import { DependencyProvider } from '@xengage/gw-portals-dependency-react';
import { policyJobComponentMap, policyJobComponents } from 'gw-capability-policyjob-react';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { AccurateBreakpointPropagation } from '@xengage/gw-jutro-adapters-react';
import { useTranslator } from '@jutro/locale';
import { routeConfirmationModal, DropdownMenuLink } from '@jutro/router';
import vmTranslator, {messages as commonMessages} from '@xengage/gw-platform-translations';
import {withMaintenancePage} from '@xengage/gw-portals-maintenance-react';
import { ServiceManager } from '@jutro/legacy/services';
import {
    platformComponents,
    platformComponentMap,
    ImageComponent,
    KnockOutPage,
} from 'gw-components-platform-react';
import PELandingPage, {
    Accounts,
    Policies,
    Activities,
    Analytics,
    AccountDetails,
    PolicyDetails,
    NewQuoteAccountSearch,
    NewQuotePage,
    SearchResults,
    QuoteDetails,
    Renewal,
    Endorsement,
    Cancellation,
    AccountBillingAndPayment,
    MakePayment,
    ContactUnderwriter,
    PaymentConfirmation,
    producerEngageComponentMap,
    producerEngageAdditionalComponents
} from 'gw-capability-gateway-react';
import { PolicyTransactionPage } from 'gw-policytransaction-react';
import { SelectProducerContextProvider } from 'gw-gateway-common-react';
import { Redirect, useHistory, Router } from 'react-router-dom';
import { ErrorBoundary } from '@xengage/gw-portals-error-react';


import {
    useAuthentication,
    withAuthenticationProvider
} from '@xengage/gw-digital-auth-react';
import { GatewayAvailabilityService } from 'gw-capability-gateway-policycommon';
import { GatewayRenewalService } from 'gw-capability-gateway-policyrenewal';
import { GatewayEndorsementService } from 'gw-capability-gateway-policychange';
import { LoadSaveService, CustomQuoteService } from 'gw-capability-gateway-quoteandbind';
import { UserService, SubmissionService, JobService, SearchService, PolicyChangeService } from 'gw-capability-gateway';
import { GatewayClaimService } from 'gw-capability-gateway-claim';
import { GatewayBillingService } from 'gw-capability-gateway-billing';
import { GatewayFNOLService } from 'gw-capability-gateway-fnol';
import { AccountService } from 'gw-capability-gateway-policy';
import { GatewayDocumentService } from 'gw-capability-gateway-document';

import { GatewaySpreadsheetService } from 'gw-capability-gateway-spreadsheet';
import { ProducerInfoService } from 'gw-capability-profileinfo';
import { WizardPageTemplateWithTitle } from 'gw-portals-wizard-components-ui';
import { AddressLookupComponentMap, AddressLookupComponents } from 'gw-capability-address-react';
import { VehicleInfoLookupComponentMap, VehicleInfoLookupComponents } from 'gw-capability-vehicleinfo-react';
import { GatewayClaimDocumentService } from 'gw-capability-gateway-claimdocument';
import { filterCapabilityRoutes } from '@xengage/gw-portals-config-js';
import '@jutro/legacy/dataview';
import '@jutro/legacy/address';
import { PolicyDocumentError } from 'gw-capability-document-react';
import { PECodegenWizard as PERecVehProductWizard } from 'gw-capability-gateway-quoteandbind-PremierRV-react';
import { PECodegenWizard as PEProLinProductWizard } from 'gw-capability-gateway-quoteandbind-PremierPL-react';
import { PECodegenWizard as PEEnvProductWizard } from 'gw-capability-gateway-quoteandbind-PremierEL-react';
import { PECodegenWizard as PEEveLiaProductWizard } from 'gw-capability-gateway-quoteandbind-PremierLE-react';
import { PECodegenWizard as PEConsTraAndServProductWizard } from 'gw-capability-gateway-quoteandbind-PremierCT-react';
import { PECodegenWizard as PESpoAndRecProductWizard } from 'gw-capability-gateway-quoteandbind-PremierSR-react';
import { PECodegenWizard as PESpeLinProductWizard } from 'gw-capability-gateway-quoteandbind-PremierSC-react';
import { PECodegenWizard as PERecMarProductWizard } from 'gw-capability-gateway-quoteandbind-PremierRM-react';
import { PECodegenWizard as PECybLiaProductWizard } from 'gw-capability-gateway-quoteandbind-PremierCL-react';
import { PECodegenWizard as PESpaAndWelProductWizard } from 'gw-capability-gateway-quoteandbind-PremierSW-react';
import { PECodegenWizard as PEPerProductWizard } from 'gw-capability-gateway-quoteandbind-PremierPR-react';
import BaseFNOLWizard, { ClaimsConfirmationPage } from 'gw-capability-fnol-common-react';
import { ContactAgentPage, Preferences } from 'gw-pages-platform-react';
import FNOLHOWizard from 'gw-capability-fnol-ho-react';
import FNOLPAWizard from 'gw-capability-fnol-pa-react';
import FNOLCAWizard from 'gw-capability-fnol-ca-react';
import FNOLCPWizard from 'gw-capability-fnol-cp-react';
import FNOLWCWizard from 'gw-capability-fnol-wc-react';
import FNOLBOPWizard from 'gw-capability-fnol-bop-react';
import FNOLGeneralWizard from 'gw-capability-fnol-gl-react';
import { PremierRVPolicyChangeWizard } from 'premier-capability-policychange-premierRV-react';
import { PremierPLPolicyChangeWizard } from 'premier-capability-policychange-premierPL-react';
import { PremierLEPolicyChangeWizard } from 'premier-capability-policychange-premierLE-react';
import { PremierELPolicyChangeWizard } from 'premier-capability-policychange-premierEL-react';
import { PremierCTPolicyChangeWizard } from 'premier-capability-policychange-premierCT-react';
import { PremierSRPolicyChangeWizard } from 'premier-capability-policychange-premierSR-react';
import { PremierRMPolicyChangeWizard } from 'premier-capability-policychange-premierRM-react';
import { PremierSLPolicyChangeWizard } from 'premier-capability-policychange-premierSL-react';
import { PremierSCPolicyChangeWizard } from 'premier-capability-policychange-premierSC-react';
import { PremierSWPolicyChangeWizard } from 'premier-capability-policychange-premierSW-react';
import { PremierPRPolicyChangeWizard } from 'premier-capability-policychange-premierPR-react';
import { PremierCLPolicyChangeWizard } from 'premier-capability-policychange-premierCL-react';
import FaqPage from 'gw-capability-faq-react';
import { ClaimDetails } from 'gw-capability-claim-react';
import { ClaimsLanding } from 'gw-capability-gateway-claim-react';
import { CommissionLanding } from 'gw-capability-gateway-commission-react';
import { checkMaintenanceMode } from "gw-maintenance-js";
import appConfig from 'app-config';


import { AppFloorPlan } from '@jutro/legacy/floorplan';
import messages from './App.messages';

import appRoutes from './App.routes.metadata.json5';
import { PolicyChange } from 'gw-capability-policychange-common-react';


const { capabilitiesConfig, env, gatewayAnalytics, applicationDetails } = appConfig;

const componentMap = {
    pePremierPRwizard: PEPerProductWizard,
    pePremierSWwizard: PESpaAndWelProductWizard,
    pePremierCLwizard: PECybLiaProductWizard,
    pePremierSCwizard: PESpeLinProductWizard,
    pePremierCTwizard: PEConsTraAndServProductWizard,
    pePremierSRwizard: PESpoAndRecProductWizard,
    pePremierLEwizard: PEEveLiaProductWizard,
    pePremierELwizard: PEEnvProductWizard,
    pePremierPLwizard: PEProLinProductWizard,
    pePremierRVwizard: PERecVehProductWizard,
    pePremierRMwizard: PERecMarProductWizard,
    landingpage: PELandingPage,
    accounts: Accounts,
    policies: Policies,
    activities: Activities,
    analytics: Analytics,
    accountdetails: AccountDetails,
    policydetails: PolicyDetails,
    newquoteaccountsearch: NewQuoteAccountSearch,
    newquotepage: NewQuotePage,
    searchresults: SearchResults,
    quotedetails: QuoteDetails,
    renewal: Renewal,
    endorsement: Endorsement,
    cancellation: Cancellation,
    accountbillingandpayment: AccountBillingAndPayment,
    makepayment: MakePayment,
    contactunderwriter: ContactUnderwriter,
    paymentconfirmation: PaymentConfirmation,
    basefnolwizard: BaseFNOLWizard,
    claimsconfirmationpage: ClaimsConfirmationPage,
    contactagentpage: ContactAgentPage,
    preferences: Preferences,
    fnolhowizard: FNOLHOWizard,
    fnolpawizard: FNOLPAWizard,
    fnolcawizard: FNOLCAWizard,
    fnolcpwizard: FNOLCPWizard,
    fnolwcwizard: FNOLWCWizard,
    fnolbopwizard: FNOLBOPWizard,
    premierrvpolicychangewizard: PremierRVPolicyChangeWizard,
    premierplpolicychangewizard: PremierPLPolicyChangeWizard,
    premierlepolicychangewizard: PremierLEPolicyChangeWizard,
    premierelpolicychangewizard: PremierELPolicyChangeWizard,
	premierctpolicychangewizard: PremierCTPolicyChangeWizard,
    premiersrpolicychangewizard: PremierSRPolicyChangeWizard,
    premierrmpolicychangewizard: PremierRMPolicyChangeWizard,
    premierscpolicychangewizard: PremierSCPolicyChangeWizard,
    premierswpolicychangewizard: PremierSWPolicyChangeWizard,
    premierprpolicychangewizard: PremierPRPolicyChangeWizard,
    premierclpolicychangewizard: PremierCLPolicyChangeWizard,
    fnolgeneralwizard: FNOLGeneralWizard,
    faqpage: FaqPage,
    knockoutpage: KnockOutPage,
    claimdetails: ClaimDetails,
    claimslanding: ClaimsLanding,
    commissionlanding: CommissionLanding,
    policydocumenterror: PolicyDocumentError,
    policytransactionpage: PolicyTransactionPage,
};

setComponentMapOverrides({
    ...platformComponentMap,
    ...AddressLookupComponentMap,
    ...VehicleInfoLookupComponentMap,
    ...producerEngageComponentMap,
    ...policyJobComponentMap,
    WizardPageTemplateWithTitle: { component: 'WizardPageTemplateWithTitle' },
    // replace the native IMG component with a proxied version
    img: { component: 'img' }
},
{
    ...platformComponents,
    ...AddressLookupComponents,
    ...VehicleInfoLookupComponents,
    ...producerEngageAdditionalComponents,
    ...policyJobComponents,
    WizardPageTemplateWithTitle,
    img: ImageComponent
});

const defaultRoutes = filterCapabilityRoutes(capabilitiesConfig, appRoutes.routes);

const getUserAuthData = (authData) => UserService.getGatewayCurrentUser(authData.authHeader).catch(() => {
        if(authData) {
            authData.logout();
        }
    });

const modalEmitter = new ModalNextEmitter();

function App() {
    const {
        showAlert
    } = useModal();
    const history = useHistory();
    const auth = useAuthentication();
    const translator = useTranslator();
    const [viewModelService, updateViewModelService] = useState(undefined);
    const [permissionCheck, updatePermissionCheck] = useState(false);
    const [routes, updateRoutes] = useState(defaultRoutes);

    const { breakpoint } = useBreakpoint({});
    const getLogoSrc = useCallback(() => {
        const selectedLanguage = ServiceManager.getService('locale-service').getStoredLanguage()
        
        let logoName = (!_.isUndefined(selectedLanguage) && selectedLanguage === 'fr-CA') ? 
                            applicationDetails.applicationQCLogo : applicationDetails.applicationLogo;

        if(breakpoint === 'phone' || breakpoint === 'phoneWide'){
            logoName = (!_.isUndefined(selectedLanguage) && selectedLanguage === 'fr-CA') ? 
            applicationDetails.applicationQCLogoMobile : applicationDetails.applicationLogoMobile;
        }

        const prefix = _.get(env, 'DEPLOYMENT_PATH', '').replace(/\/$/, '');

        return `${prefix}/${logoName}`;
    }, [breakpoint]);

    useEffect(
        () => {
            const translatorFn = vmTranslator(translator);

            import(
                /* webpackChunkName: "product-metadata" */

                'product-metadata'
            ).then((productMetadata) => {
                if(!productMetadata || _.isEmpty(productMetadata.default)) {
                    throw new Error(translator(messages.errorMetadataMessage));
                }

                const { default: result } = productMetadata;

                updateViewModelService(
                    ViewModelServiceFactory.getViewModelService(result, translatorFn)
                );

                const image = document. querySelector('img[alt="Application Logo"]')

                if(image) {
                     image.alt ="Presto Logo - Home page"
                }
            });
        },
        [translator]
    );

    const handleError = useCallback((error = {}) => {
        const state = {
            pathname: '/',
            state: error
        };

        return showAlert({
            title: messages.error,
            message: messages.errorMessage,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).then(
            () => <Redirect to={state} />,
            _.noop
        );
    }, [showAlert]);

    const avatarLinks = useMemo(() => [
            <DropdownMenuLink aria-label="Profile menu button expanded FAQ"
                key="faq" to="/faq">{translator(messages.faq)}</DropdownMenuLink>,
            <DropdownMenuLink key="preferences" to="/preferences">{translator(messages.preferences)}</DropdownMenuLink>,
        ], [translator]);

    // As part of the defect DE3156 commission and Analytics is not required
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const checkViewCommissionsAnalyticsPermission = useCallback(() => {
        const commissionsDTO = {
            permission: 'viewcommissions'
        };

        const reportsDTO = {
            permission: 'gpaviewreports'
        };

        if(_.isEmpty(auth.authHeader) || permissionCheck) {
            return;
        }

        updatePermissionCheck(true);

        const commissionPermission = UserService.hasUserSystemPermission(commissionsDTO, auth.authHeader);

        const analyticsPermission = UserService.hasUserSystemPermission(reportsDTO, auth.authHeader);

        Promise.all([commissionPermission, analyticsPermission])
            .then(([hasCommission, hasAnalytics]) => {

                const routesToBeUpdated = ['/commission', '/analytics'];
                let updatedRoutes = 0;

                for (const route of routes) {
                    if (routesToBeUpdated.includes(route.path)) {
                        updatedRoutes += 1;
                        route.showOnNavBar = (
                            route.path === '/commission' ? hasCommission : gatewayAnalytics && hasAnalytics
                        );
                    }

                    if(routesToBeUpdated.length === updatedRoutes) {
                        break;
                    }
                }

                updateRoutes([...routes]);
            });


    }, [auth.authHeader, permissionCheck, routes]);

    const onSearchValueChange = useCallback((selectedValue) => {
        const searchText = _.get(selectedValue, 'id', '');

        if (!_.isEmpty(searchText)){
            let redirectPath = `/search/${searchText}`;

            if (_.get(selectedValue, 'type', '') === 'account') {
                redirectPath = `/accounts/${searchText}/summary`;
            }

            if (_.get(selectedValue, 'type', '') === 'policy') {
                redirectPath = `/policies/${searchText}/summary`
            }

            history.push(redirectPath);
        }
    }, [history]);

    const formatSearchValues = useCallback((displayName, id, type) => {
        const availableObject = {
            displayName,
            id,
            type
        };

        return availableObject;
    }, []);

    const handleLoadValues = useCallback(async (searchParam) => {
        const searchObj = {
            previousSearchParam: '',
            searchParam
        };
        const displayName = translator(messages.viewAll, { Number: searchParam});
        const viewAll = formatSearchValues(displayName, searchParam, '');
        const searchResults = await SearchService.search(searchObj, auth.authHeader);
        const availableValues = [viewAll];

        if (!_.isEmpty(searchResults)) {
            const { accounts, policies } = searchResults;

            if (!_.isEmpty(accounts)) {
                _.each(accounts, (account) => {
                    availableValues.push(formatSearchValues(`${account.accountHolder} - ${account.accountNumber}`, account.accountNumber, 'account'));
                })
            }

            if (!_.isEmpty(policies)) {
                _.each(policies, (policy) => {
                    availableValues.push(formatSearchValues(`${policy.accountNumber} - ${policy.policyNumber}`, policy.policyNumber, 'policy'));
                })
            }
        }

        return availableValues;
    }, [auth.authHeader, formatSearchValues, translator]);

    const floorPlansConfig = useMemo(() => [{
            scrollContent: false,
            showFooter: false,
            routes,
            header: {
                avatarChildren: avatarLinks,
                avatarProps: {
                    username: auth.userInfo.name,
                    title: _.get(auth, 'authUserData.displayName'),
                    subtitle: _.capitalize(_.get(auth, 'authUserData.userType'))
                },
                className: 'appHeader',
                logoSrc: getLogoSrc(),
                onSearchValueChange,
                onLoadValues: handleLoadValues,
                showAppSwitcher: false,
                showNotifications: false,
                searchFieldPlaceholder: messages.searchPlaceHolder,
                searchOptionTypes:[
                    {
                      "type": "account",
                      "icon": "gw-account-box",
                      "displayName": translator(messages.account)
                    },
                    {
                      "type": "policy",
                      "icon": "gw-policy",
                      "displayName": translator(messages.policy)
                    },
                    {
                        "type": "",
                        "displayName": " "
                    }
                  ]
            }
        }], [auth, avatarLinks, getLogoSrc, handleLoadValues, onSearchValueChange, routes, translator]);

    useEffect(() => {
        // checkViewCommissionsAnalyticsPermission();
    }, []);

    return (
        <AccurateBreakpointPropagation>
            <DependencyProvider
                value={{
                    LoadSaveService,
                    CustomQuoteService,
                    ClaimService: GatewayClaimService,
                    ClaimDownloadService: GatewayClaimDocumentService,
                    FNOLService: GatewayFNOLService,
                    AvailabilityService: GatewayAvailabilityService,
                    RenewalService: GatewayRenewalService,
                    DocumentService: GatewayDocumentService,
                    SpreadsheetService: GatewaySpreadsheetService,
                    EndorsementService: GatewayEndorsementService,
                    AccountService,
                    BillingService: GatewayBillingService,
                    UserService,
                    ContactService: ProducerInfoService,
                    quoteUnderWritingService: {
                        referToUnderwriter: SubmissionService.referToUnderwriter,
                        withdrawJobByJobNumber: JobService.withdrawJobByJobNumber,
                        approveUnderwritingIssue: LoadSaveService.approveUnderwritingIssue
                    },
                    policychangeUnderWritingService: {
                        referToUnderwriter: PolicyChangeService.referToUnderwriter,
                        withdrawJobByJobNumber: JobService.withdrawJobByJobNumber,
                        approveUnderwritingIssue: LoadSaveService.approveUnderwritingIssue
                    }
                }}
            >
                <ViewModelServiceContext.Provider value={viewModelService}>
                    <ErrorBoundary onError={handleError}>
                        <SelectProducerContextProvider>
                            <Router history={history} basename="/producer-engage" getUserConfirmation={(message,callback)=>routeConfirmationModal(message,callback,modalEmitter)}>
                                <AppFloorPlan
                                    componentMap={componentMap}
                                    floorPlans={floorPlansConfig}
                                />
                            </Router>
                        </SelectProducerContextProvider>
                    </ErrorBoundary>
                </ViewModelServiceContext.Provider>
            </DependencyProvider>
        </AccurateBreakpointPropagation>
    );
}

export default withAuthenticationProvider({onAuthDataCreation: getUserAuthData})(withMaintenancePage({appConfig, checkMaintenanceMode})(App));
